<template>
  <div class="web-box-all">
    <ext-header select_menu="8"></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
          <ext-nav></ext-nav>
        </div>
        <div class="web-order-right">

          <div class="web-order-title">
            <ul>
              <li :class="[menu_select=='0' ? 'select' : '']" @click="set_order_state('0')">
                <a>全部订单</a>
              </li>
              <li :class="[menu_select=='1' ? 'select' : '']" @click="set_order_state('1')">
                <a>待审核</a>
              </li>
              <li :class="[menu_select=='2' ? 'select' : '']" @click="set_order_state('2')">
                <a>已审核</a>
              </li>
              <li :class="[menu_select=='3' ? 'select' : '']" @click="set_order_state('3')">
                <a>已驳回</a>
              </li>
              <li :class="[menu_select=='4' ? 'select' : '']" @click="set_order_state('4')">
                <a>已完成</a>
              </li>
            </ul>
          </div>

          <div class="web-order-list-box">

            <ext-loading v-if="list_data.length==0" style="width:100%;" title="当前没有消息"></ext-loading>

            <div class="web-order-list-data" v-for="(vo,index) in list_data" :key="index">
              <div class="web-order-list-title" @click="get_order_show(vo.id)">
                <h2>退货单号：{{vo.return_no}}</h2>
                <p>订单详情<span>（{{vo.return_state_name}}）</span></p>
              </div>
              <div class="web-order-list-goods" @click="get_order_show(vo.id)">
                <ul>
                   <li v-for="(voo,key) in vo.goods" :key="key">
                    <img src="@/assets/goods_load.png" v-real-img="web_url+voo.goods_image">
                    <p>
                      <a>{{voo.goods_name}}</a>
                      <b>{{voo.goods_no}}</b>
                    </p>
                    <h2>
                      <a>￥{{voo.price}}</a>
                      <a>x {{voo.qty}}</a>
                    </h2>
                  </li>
                </ul>
              </div>
              <div class="web-order-list-money">
                <h2>{{vo.ctime}}</h2>
                <p>(仅供参考)应退金额：<span>￥{{vo.return_fee}}</span></p>
              </div>
              <div class="web-order-list-auto">
                <p>
                  <a style="display:none" v-if="vo.return_state!=2" @click="return_del(vo.id)">取消</a>
                  <a v-if="vo.return_state==2" @click="get_order_show(vo.id)">继续退货</a>
                </p>
              </div>
            </div>

          </div>

          <div class="web-order-list-page">
            <b-pagination
              v-model="currentPage"
              :total-rows="list_data.length"
              :per-page="perPage"
              first-number
              last-number
            >
            <template #prev-text><span class="lemon-page">上一页</span></template>
            <template #next-text><span class="lemon-page">下一页</span></template>
            <template #page="{ page, active }">
              <b class="lemon-page-now" v-if="active">{{ page }}</b>
              <i class="lemon-page-line" v-else>{{ page }}</i>
            </template>
            </b-pagination>
          </div>

        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <b-modal id="bv-modal-order-tip" centered  hide-footer>
      <template #modal-title>
        提示
      </template>
      <div class="d-block text-center">
        <h6>确定取消这个退货申请单吗？</h6>
      </div>
      <div class="web-modal-foot">
        <a @click="$bvModal.hide('bv-modal-order-tip')" class="no">取消</a>
        <a @click="ok_exchange();$bvModal.hide('bv-modal-order-tip')" class="ok">确认</a>
      </div>
    </b-modal>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import ExtLoading from '@/components/loading/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'

export default {
  name: 'return_order_list',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav,
    'ext-loading': ExtLoading
  },
  data () {
    return {
      title: '订单列表',
      web_url: webUrl(),
      menu_select: 0,
      perPage: 10,
      currentPage: 1,
      list_data: [],
      list_count: 0,
      select_del_id: ''
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    set_order_state (id) {
      this.menu_select = id
      this.load_data()
    },
    return_del (id) {
      this.select_del_id = id
      this.$bvModal.show('bv-modal-order-tip')
    },
    ok_exchange () {
      var returnId = this.select_del_id
      var that = this
      ajax({
        url: '/store/order/return_order_del',
        method: 'post',
        data: {
          uid: getUserId(),
          return_id: returnId
        }
      }, function (ret) {
        that.select_del_id = ''
        that.load_data()
      })
    },
    get_order_show (orderNo) {
      this.$router.push({path: '/order/return_order_show', query: {v: Encrypt(orderNo)}})
    },
    load_data () {
      var that = this
      var page = this.currentPage
      var menuSelect = this.menu_select
      ajax({
        url: '/store/order/return_order_list',
        method: 'post',
        data: {
          uid: getUserId(),
          return_state: menuSelect,
          page: page
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.list_data = ret.data.list_data
          that.list_count = ret.data.list_count
        } else {
          that.list_data = []
          that.list_count = 0
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-order-title { width:100%; height:50px; border-bottom: 1px solid #dfdfdf;}
      .web-order-title ul { width:400px; height:50px; list-style:none; margin:0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
      .web-order-title ul li { width:80px; height:50px; cursor: pointer; line-height: 50px; font-size:14px; text-align: center;justify-content:center; }
      .web-order-title ul li a { color:#333333;}
      .web-order-title ul li a:hover { color:#d81e06; font-weight: bold;}
      .web-order-title ul li.select { border-bottom: 2px solid #d81e06;}
    .web-order-list-box { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-order-search { width:100%; height:50px; margin-top:10px; border:1px solid #dfdfdf; background: #f5f5f5; flex-flow:row; justify-content:space-between;}

    .web-order-search-main { width:auto; height:50px; flex-flow:row; justify-content:flex-start;}
      .web-order-type-select { width:110px; height:50px; flex-flow:row; justify-content:flex-start;}
      .web-order-type-select img { width:20px; height:20px; margin: 16px 7px 0px 15px;}
      .web-order-type-select p { width: 60px; height:30px; margin-top:10px; line-height:30px; font-size: 12px; color:#333333;}
      .web-order-type-select p select { border:0px; margin:0px !important; padding:0px !important;}
      .web-order-input { width:200px; height:32px; margin-top:10px; border:1px solid #dfdfdf;}
        .web-order-input input { width:198px; height:30px; line-height:30px; padding-left:10px; font-size:14px; color:#333333; border:0px; margin-top:0px;}
      .web-order-search-ok { width: 100px; height:32px; margin:10px 0px 0px 10px;}
        .web-order-search-ok a { width: 100px; height:32px; cursor: pointer; border-radius: 4px; line-height: 32px; text-align: center; font-size:14px; color:#ffffff;justify-content:center;  background: #d81e06;}
        .web-order-search-ok a:hover { color:#ffffff;}

      .web-order-date-select { width:200px; height:50px; flex-flow:row; justify-content:flex-end;}
      .web-order-date-select p { width: auto; height:30px; margin-top:10px; margin-right:15px; line-height:30px; font-size: 12px; color:#333333;}
      .web-order-date-select p select { border:0px; margin:0px !important; padding:0px !important;}

    .web-order-list-data { width:100%; height:auto; border:1px solid #dfdfdf; margin-top:15px; flex-wrap:wrap; align-content:flex-start;}
      .web-order-list-title { width:100%; height:40px; padding:0px 15px; background: #f5f5f5; flex-flow:row; justify-content:space-between;}
      .web-order-list-title h2 { width:auto; height:40px; line-height:40px; font-size:14px; color:#333333;}
      .web-order-list-title h2 span { width:auto; height:40px; line-height:40px; margin-left:20px; font-size:14px; color:#aaaaaa;}
      .web-order-list-title p { width:auto; height:40px; line-height:40px; cursor: pointer; font-size:14px; color:#333333;}
      .web-order-list-title p span { width:auto; height:40px; line-height:40px; font-size:14px; color:#aaaaaa;}
      .web-order-list-goods { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; }
      .web-order-list-goods ul { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; list-style:none; margin:0px; padding:0px;}
      .web-order-list-goods ul li { width:100%; height:90px; flex-flow:row; justify-content:flex-start; margin:0px; padding:15px; border-bottom: 1px solid #dfdfdf;}
      .web-order-list-goods ul li img { width:60px; height:60px; margin-right:20px;}
      .web-order-list-goods ul li p { width:520px; height:60px;  flex-wrap:wrap; align-content:flex-start;}
      .web-order-list-goods ul li p a { width:100%; height:40px; line-height:20px; font-size:14px; color:#333333;}
      .web-order-list-goods ul li p a:hover { color:#333333;}
      .web-order-list-goods ul li p b { width:100%; height:20px; font-weight: normal; line-height:20px; font-size:14px; color:#aaaaaa;}
      .web-order-list-goods ul li h2 { width:150px; height:60px;  flex-wrap:wrap; align-content:flex-start;}
      .web-order-list-goods ul li h2 a { width:100%; height:20px; line-height:20px; font-size:14px; color:#333333; text-align: right; justify-content:flex-end; }
      .web-order-list-goods ul li h2 a:hover { color:#333333;}
      .web-order-list-money { width:100%; height:40px; flex-flow:row; padding:0px 15px; justify-content:space-between; }
      .web-order-list-money h2 { width:auto; height:40px; line-height:40px; font-size:14px; color:#aaaaaa;}
      .web-order-list-money h2 span { font-size:14px; color:#333333;}
      .web-order-list-money p { width:auto; height:40px; line-height:40px; font-size:14px; color:#333333;}
      .web-order-list-money p span { color:#d81e06}
      .web-order-list-auto { width:100%; height:50px;  flex-flow:row;justify-content:flex-end; }
      .web-order-list-auto p { width:100%; height:30px; margin-top:5px; flex-flow:row;justify-content:flex-end;  }
      .web-order-list-auto p a { width:100px; height:30px; cursor: pointer; margin-right: 15px; line-height:28px; font-size: 12px;  text-align: center; justify-content: center; border: 1px solid #dfdfdf; color:#333333; border-radius: 4px;}
      .web-order-list-auto p a:hover { color:#333333;}
      .web-order-list-auto p a.red { color:#ffffff; background: #d81e06;}
      .web-order-list-auto p a.red:hover { color:#ffffff;}

    .web-order-list-page { width:100%; height:40px; margin-top:20px;}

    .lemon-page { color:#333333; font-size:14px; height:24px; line-height:24px;}
    .lemon-page-now { background: #d81e06 !important; color:#ffffff !important; width:24px; height:24px;}
    .lemon-page-line { color:#333333; font-style: normal;}

</style>
<style>
  .page-item.active .page-link { border:1px solid #d81e06;background: #d81e06 !important; color:#ffffff !important;}
</style>



// WEBPACK FOOTER //
// src/pages/order/return_order_list.vue